import gsap from "gsap";
import { pageReady } from "./page-ready";
import PixelReveal from "../components/global/pixel-reveal";

// Same translate/fade stagger used for the shop grid (see Products#animateCards),
// triggered once when the container first enters the viewport.
export function animateCardsIn(container, selector = ".c-product-card", { rootMargin = "0px 0px -25% 0px" } = {}) {
  // Includes keen-slider's loop-fill duplicates (aria-hidden clones) so the
  // carousel doesn't look half-animated when the real card count is low.
  const cards = [...container.querySelectorAll(selector)];
  if (!cards.length) return;

  // Keen-slider drives its own transform on the slide root (the card itself
  // inside a slider), so animate the inner wrapper instead to avoid the two
  // fighting over the `transform` property.
  const targets = cards.map((card) => card.querySelector(".c-product-card__inner") || card);

  // In a keen-slider loop, the last DOM slide (a duplicate) is positioned to
  // the left of slide 0, so it's the first one visible — animate it first,
  // then the rest in their normal order, instead of last.
  const isSlider = container.classList.contains("keen-slider");
  const staggerTargets = isSlider ? [targets[targets.length - 1], ...targets.slice(0, -1)] : targets;

  gsap.set(targets, { y: '20%', opacity: 0 });
  targets.forEach((t) => PixelReveal.claim(t));

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) return;
      observer.disconnect();
      pageReady.ready.then(() => {
        gsap.to(staggerTargets, { y: 0, opacity: 1, duration: 0.5, ease: "power4.out", stagger: 0.06 });
        staggerTargets.forEach((t, i) => PixelReveal.play(t, i * 0.06));
      });
    },
    { threshold: 0, rootMargin }
  );

  observer.observe(container);
}
